<template>
    <div class=" marginL201 clearfix">
        <div class="login-title h50">
            <span></span>
            我的收入
        </div>
        <div class="incom-title">
        <p ><span>{{bankName?bankName:"你还没有设置银行卡"}}</span><span style="margin-left:20px;">{{bankAccount}}</span><span @click="changes" style="margin-left:40px;color:#01abac;">去设置</span></p>
        </div>
        <div class="income-wrap">
            <div class="h100 income-show">
                <div class="income-box">
                    <div class="income-boxss" style="width:60px;">
                        <img src="../../../images/incomeleft.png" alt="">
                    </div>
                    <div class="income-boxss" style="width:200px;background: #F4F9FF;">
                        <p class="income-show-content fontSize14 h40" style="color:#00B2B1;">我的余额</p>
                        <p class="fee-num fontSize18" style="text-align: center;line-height: 60px;color:#242F3A;">￥{{ balance?(parseFloat(balance)/100).toFixed(2):"0.00"}}</p>
                    </div>
                </div>
                <div class="income-box">
                    <div class="income-boxss" style="width:60px;">
                        <img src="../../../images/incomemiddle.png" alt="">
                    </div>
                    <div class="income-boxss" style="width:200px;background: #F4F9FF;">
                        <p class="income-show-content fontSize14 h40" style="color:#FFBF1B;">累计收益</p>
                        <p class="fee-num fontSize18" style="text-align: center; line-height: 60px;color:#242F3A;">￥{{ totalIncome?(parseFloat(totalIncome)/100).toFixed(2):"0.00" }}</p>
                    </div>
                </div>
                <div class="income-box">
                    <div class="income-boxss" style="width:60px;">
                        <img src="../../../images/incomeright.png" alt="">
                    </div>
                    <div class="income-boxss" style="width:200px;background: #F4F9FF;">
                        <p class="income-show-content fontSize14 h40" style="color:#242F3A;">本月收益</p>
                        <p class="fee-num fontSize18" style="text-align: center;line-height: 60px;color:#242F3A;">￥{{ monthIncome?(parseFloat(monthIncome)/100).toFixed(2):"0.00" }}</p>
                    </div>
                </div>
            </div>
            <p style="font-size: 14px;color:#666665;line-height:40px;">这里显示的都是扣除平台或医院管理费用后的税前收入</p>
            <SetUpIncomeTableCmp :propsTableData="contentData" class="marginT20"/>
            <FooterCmp :propsTotalCols="propsTotalCols" @changePage="changePage"  :propsPageSize="6" :fixedHeight="500"/>
        </div>
        <div class="income-boxs" v-show="showboxs">

        </div>
        <div class="income-shows" v-show="showshows">
          <p style="text-align: center;line-height: 50px;">更换银行卡提示</p>
            <p style="margin-top:20px;text-align: center;line-height:20px;color:#999999;font-size: 14px;padding:0px 60px ">为便于财务统计，平台将对提现银行卡进行规范，要求发卡银行统一为<span style="color:red;">中国工商银行，其他银行卡暂停止使用</span>，请重新设置银行卡
            </p>
            <div class="table-btn-wrap  income-position">
                <el-button
                        style="width:122px;height:30px;line-height: 30px;"
                        @click="closes"
                        class="table-btn ghost-btn h24 w112">
                    下次再说
                </el-button>
                <el-button
                        type="primary"
                        style="width:122px;height:30px;line-height: 30px;margin-left:40px;"
                        @click="changes1"
                        class="table-btn operate h24 w112">
                    去设置
                </el-button>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
    import SetUpIncomeTableCmp from "./SetUpIncomeTableCmp.vue"
    import FooterCmp from "../common/FooterCmp.vue";
    import axiosUtil from "../../utils/AxiosUtils.js"
    export default{
        data: function(){
            return{
                showboxs:false,
                showshows:false,
                contentData: [],
                totalIncome: 0,// 总收入
                balance:0,
                monthIncome:0,
                bankAccount:"",
                bankName:"",
                propsTotalCols: 0,//列表总数量
            }
        },
        props: ["clientH"],
        components:{
            SetUpIncomeTableCmp,
            FooterCmp
        },
        computed: {
            /*contentDataArr: function(){
                const totalsCols = this.contentData.length;
                const start = (this.currentPage - 1) * 6;//6表示每页显示行数
                //end如果大于数组总长度则数值改为数组总长度
                const end = (this.currentPage * 6 > totalsCols) ? totalsCols : (this.currentPage * 6);
                return this.contentData.slice(start, end);
            }*/
        },
        created: function(){
            this.getData();
        },
        mounted:function(){
           this.getDocInfo();
        },
        methods: {
            closes:function(){
               let _this=this;
                _this.showboxs=false;
                _this.showshows=false;
            },
            getDocInfo:function(){
                let _this=this;
                let options={
                    // Service:"nethos.doc.bank.get",
                    Service:"nethos.doc.bank.get",
                    token: localStorage.getItem("token"),
                }
                axiosUtil(options,function(data){
                    
                    if(data.obj.bankName!="中国工商银行"){
                        _this.showboxs=true,
                            _this.showshows=true
                    }
                    _this.bankAccount=data.obj.bankAccount;
                    _this.bankName=data.obj.bankName;
                })
            },
            changes:function(){
                let _this=this;
                if(_this.bankName=="中国工商银行"){
                    _this.$router.push("/setUp/yhInfo");
                }else if(_this.bankName==""){
                    _this.$router.push("/setUp/yhInfo");
                }else{
                    _this.showboxs=true,
                        _this.showshows=true
                }
            },
            changes1:function(){
                let _this=this;
                _this.$router.push("/setUp/yhInfo");
            },
            /*splitDataArr: function(contentData, currentPage ,num){//分割数组，参数1：需要分割的数组，参数2：对应表单的当前页数，参数3：列表每页显示的行数(需要css样式列表高度配合),
                const totalsCols = contentData.length;
                const start = (currentPage - 1) * num;
                //end如果大于数组总长度则数值改为数组总长度
                const end = (currentPage * num > totalsCols) ? totalsCols : (currentPage * num);
                return contentData.slice(start, end);
            },*/
            getData: function(pageNo = 1){// 获取收入列表数据
                let _this = this;
                let options = {
                    pageNum: pageNo,
                    pageSize: 6,
                    docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
                    token: localStorage.getItem("token"),
                    // Service: "nethos.pay.docmakemoney.list"
                    Service: "smarthos.pay.makemoney.list"
                };
                axiosUtil(options, function(data){
                    
                    _this.propsTotalCols = data.paginator.totalCount;
                    _this.contentData = data.list;
                    _this.totalIncome= data.payBalanceVo.income;
                    _this.balance=data.payBalanceVo.balance;
                    _this.monthIncome=data.payBalanceVo.monthIncome;
                })
            },
            changePage: function(pageNo){//页码改变
                this.getData(pageNo);
            },
        }
    }
</script>
